import { useState } from 'react';
import { useWallet } from '@txnlab/use-wallet-react';
import { makePaymentTransaction, processCreditPurchase } from '../services/api/subscriptionApi';
import { notify } from '../utils/toast';
import { storage } from '../lib/storage';

export const useTransaction = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { activeAddress, activeAccount, algodClient, transactionSigner } = useWallet();

  const handleCreditPurchase = async (amount: number): Promise<void> => {
    if (!algodClient || !activeAddress || !activeAccount) {
      notify.error('Wallet not connected');
      return;
    }

    setIsLoading(true);
    try {
      // Create and sign transaction using transactionSigner from useWallet
      const signedTxn = await makePaymentTransaction(
        amount,
        activeAddress,
        algodClient,
        transactionSigner
      );

      if (!signedTxn) {
        throw new Error('Failed to create transaction');
      }

      // Process the credit purchase
      const result = await processCreditPurchase(activeAddress, signedTxn);
      if (!result) {
        throw new Error('Failed to process credit purchase! Check your balance!');
      }

      // Update the UI with the new credit balance
      // This will trigger a re-render of components that use the profile
      const profile = await storage.getProfile(activeAddress);
      if (profile) {
        // Force a refresh of the profile in components that use it
        const event = new CustomEvent('creditUpdate', { detail: { credit: result.credit } });
        window.dispatchEvent(event);
        
        console.log('Credit purchase successful. New balance:', result.credit);
      }

    } catch (error: any) {
      console.error('Credit purchase error:', error);
      notify.error(error.message || 'Failed to purchase credits');
    } finally {
      setIsLoading(false);
      notify.success('Top-up transaction completed!');
    }
  };

  return {
    handleCreditPurchase,
    isLoading
  };
};
